import axios from 'axios'
export default {
  resetPedidos ({state, commit, rootGetters}) {
    commit('resetPedidos')
  },
  getOrdersReport ({state, commit, rootGetters}, payload) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true, { root: true })
      axios({
        method: 'post',
        url: process.url + 'Reports/GetOrders',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: payload
      })
      .then((response) => {
        commit('toggleLoadingMounted', false, { root: true })
        commit('setPedidos', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('shared/toggleLoadingMounted', false, { root: true })
        commit('toastrAxiosError', error)
      })
    })
  },
  getStatusRelatorio ({state, commit, rootGetters}, payload) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true, { root: true })
      axios({
        method: 'get',
        url: process.url + 'Reports/GetStatus',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false, { root: true })
        commit('setStatus', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('shared/toggleLoadingMounted', false, { root: true })
        commit('toastrAxiosError', error)
      })
    })
  },
  getBusinessPartner ({state, commit, rootGetters}, payload) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true, { root: true })
      axios({
        method: 'get',
        url: process.url + 'Reports/GetPartnerBusiness',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false, { root: true })
        commit('setFornecedores', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false, { root: true })
        commit('toastrAxiosError', error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/relatorios/actions.js